'use strict';

exports.__esModule = true;

var _doctifyUtils = require('doctify-utils');

var LandingPagesActions = {
	getKeywordLandingPages: function getKeywordLandingPages(keywordType, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'keywords/landing_pages?keyword_type=' + keywordType,
			method: 'GET',
			actionType: keywordType.toUpperCase() + '_LANDING_PAGES',
			keyword: 'keywords',
			xhrConfig: xhrConfig
		});
	}
};
exports.default = LandingPagesActions;


// WEBPACK FOOTER //
// ./components/home-page/lib/actions/landing-pages.js